import React, { useEffect, useState } from 'react';

import EditableInput from '../../components/EditableInput';
import { Button, Divider, MenuItem, Select } from '@material-ui/core';
import UneditableInput from '../../components/UneditableInput';
import { Badge } from '@getpingback/realeza';

import { getCourseById, updateCourse } from '../../services/education';
import ModulesSection from './components/ModulesSection';
import ContentEditor from './components/ContentEditor';
import { toast } from '@getpingback/realeza';

import { createCourse } from '../../services/education';

const EducationCourse = props => {
  const id = props?.match.params.id;

  const [course, setCourse] = useState({});
  const [courseId, setCourseId] = useState(null);

  useEffect(() => {
    if (id) {
      setCourseId(id);
      getCourseInformation(id);
    }
  }, [id]);

  const courseData = {
    name: course.name,
    description: course.description,
    content: course.content,
    bannerUrl: course.bannerUrl,
    certificateUrl: course.certificateUrl,
  };

  const getCourseInformation = async id => {
    try {
      const { data } = await getCourseById(id);
      setCourse(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreateCourse = async () => {
    try {
      const response = await createCourse({ ...courseData, category: course.category });
      setCourseId(response.data.id);
      getCourseInformation(response.data.id);
      toast.success('Course created successfully');
    } catch (error) {
      console.error(error);

      toast.error(`Error creating course: ${error?.response?.data?.error?.message}`);
    }
  };

  const handleUpdateCourse = async () => {
    try {
      await updateCourse(id, courseData);
      getCourseInformation();
    } catch (error) {
      console.error(error);
      toast.error(`Error updating course: ${error?.response?.data?.error?.message}`);
    }
  };

  const handleSave = () => {
    if (id) {
      handleUpdateCourse();
    } else {
      handleCreateCourse();
    }
  };

  const editable = ['name', 'description', 'bannerUrl', 'certificateUrl'];
  const uneditable = ['id', 'createdAt', 'updatedAt'];

  return (
    <div className="education__course">
      <div className="education__course__header">
        <h1>{courseId ? course?.name : 'New Course'}</h1>
        <Button variant="contained" onClick={handleSave}>
          {courseId ? 'Save' : 'Create'}
        </Button>
      </div>
      <section className="education__course__edit">
        <h2>{courseId ? 'Edit Course' : 'New Course'}</h2>
        <form onSubmit={() => {}} className="education__course__edit__form">
          <div className="education__course__edit__form__fields">
            {courseId && (
              <div>
                <UneditableInput data={course} labels={uneditable} />
              </div>
            )}
            <div className="education__course__edit__form__fields__editable">
              <div className="education__course__edit__form__fields__editable__category">
                <label>Category</label>
                {courseId ? (
                  <Badge bgColor="green" label={course?.category} labelColor="white" textTransform="uppercase" />
                ) : (
                  <div className="education__course__edit__form__fields__editable__category--select">
                    <Select value={course?.category} onChange={e => setCourse({ ...course, category: e.target.value })}>
                      <MenuItem value={'mentorship'}>Mentorship</MenuItem>
                      <MenuItem value={'certification'}>Certification</MenuItem>
                    </Select>
                  </div>
                )}
              </div>
              <EditableInput data={course} setData={setCourse} labels={editable} />
            </div>
          </div>

          <ContentEditor content={course?.content} setContent={value => setCourse({ ...course, content: value })} />
        </form>
        <Divider />
        {courseId && (
          <ModulesSection modules={course?.EducationModules} courseId={courseId} onCreated={() => getCourseInformation(courseId)} />
        )}
      </section>
    </div>
  );
};

export default EducationCourse;
